export const recursiveReplace = (obj, replacements) => {
  /**
   * Given an object and a replacement array in the format:
   *      [ {find: "this", replace: "other"}, ...]
   * it will recursively replace "find" value by "replace" value
   * @param obj Object to have the values recursively replaced
   * @param replacements Array of objects specifying the find and replace
   */
  if (obj === undefined || obj === null) {
    return;
  }
  try {
    Object.getOwnPropertyNames(obj).forEach(function (k) {
      if (typeof obj[k] === 'object' && ![undefined, null].includes(obj[k])) {
        recursiveReplace(obj[k], replacements);
      } else if (typeof obj[k] === 'string') {
        replacements.forEach((r) => {
          if (obj[k].includes(r.find)) {
            obj[k] = obj[k].replace(r.find, r.replace);
          }
        });
        // } else {
        //   replacements.forEach((r) => {
        //     if (obj[k] === r.find) {
        //       obj[k] = r.replace;
        //     }
        //   });
      }
    }, replacements);
  } catch (TypeError) {
    console.log('recursiveReplace failed for ' + obj);
  }
};
